// services/area.service.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IArea } from "../areaModal";

export const getAllAreas = createAsyncThunk("Area/FindAllArea", async () => {
  try {
    const response = await axiosApiInstance.post(
      `${API_URL}/Area/FindAllArea`,
      {
        Title: "",
      },
    );
    return response.data?.Data.length > 0
      ? response.data?.Data?.map((area: any) => ({
          ...area,
          IsDisplayInHome: area.IsDisplayInHome ? "Yes" : "No",
        }))
      : [];
  } catch (error: any) {
    console.error("Error Fetching Areas:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const createArea = createAsyncThunk(
  "Area/InsertArea",
  async (areaData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Area/InsertArea`,
        areaData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Area:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateArea = createAsyncThunk(
  "Area/UpdateArea",
  async (areaData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Area/UpdateArea`,
        areaData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Area:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteArea = createAsyncThunk(
  "Area/DeleteArea",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Area/DeleteArea`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Area:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAreaByID = createAsyncThunk(
  "Area/FindByIDArea",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Area/FindByIDArea`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        ShortDescription: result.ShortDescription,
        IsDisplayInHome: result.IsDisplayInHome,
        SequenceNo: result.SequenceNo,
        CityID: result.CityID,
        CityName: result.CityName,
        StateID: result.StateID,
        StateName: result.StateName,
        ImageUpload: result.ImageUpload,
        IsActive: result.IsActive ? 1 : 2,
      } as IArea;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Area:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveAreas = createAsyncThunk(
  "Area/FindAllActiveArea",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Area/FindAllActiveArea`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active Areas:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const activeInactiveArea = createAsyncThunk(
  "Area/ActiveInActiveArea",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Area/ActiveInActiveArea`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Area:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD
export const areaImageUpload = createAsyncThunk(
  "Area/SingleImageUpload",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Area/SingleImageUpload`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error uploading Area Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
